<div class="flex-row">
  <h2 class="page-header">Borden</h2>

  <button
    mat-flat-button
    class="action-button"
    style="margin: 20px"
    (click)="addSign()"
  >
    + Bord toevoegen
  </button>
</div>

<button
  mat-flat-button
  style="margin: 0 20px 20px 0"
  (click)="toggleOldLayouts()"
  [ngClass]="{ 'activated-filter': showOldLayouts }"
>
  Oude borden
</button>

<button
  mat-flat-button
  style="margin: 0 20px 20px 20px"
  (click)="toggleLowStock()"
  [ngClass]="{ 'activated-filter': showLowStock }"
>
  Min. voorraad
</button>

<button
  mat-flat-button
  style="margin: 0 20px 20px 20px"
  (click)="toggleOnFrame()"
  [ngClass]="{ 'activated-filter': showOnFrame }"
>
  Op kader
</button>

<button
  mat-flat-button
  style="margin: 0 20px 20px 20px"
  (click)="toggleOnRoof()"
  [ngClass]="{ 'activated-filter': showOnRoof }"
>
  Dak vs rek
</button>

<div class="flex-col">
  <div class="flex-table">
    <div class="flex-header-row">
      <div
        class="flex-table-cell flex-4 clickable"
        (click)="activateSort('companyRegularName')"
        [ngClass]="{ 'sort-active': activeSort === 'companyRegularName' }"
      >
        <label class="clickable">Bedrijf</label>
        <mat-icon>
          <ng-container *ngIf="activeSortAscending; else descending">
            arrow_upward
          </ng-container>

          <ng-template #descending>arrow_downward</ng-template>
        </mat-icon>
        <filter-input
          [filterObject]="
            getFilterForKey('signHasParticipatingCompany__company__name')
          "
          [isDate]="false"
          (click)="$event.preventDefault() && $event.stopPropagation()"
          (toggleFilterEmitter)="toggleFilter($event)"
          (filterValueChanged)="onFilterValueChange($event)"
        ></filter-input>
      </div>

      <div class="flex-table-cell flex-1">
        <div class="header-icon-container">
          <mat-icon class="fa-2x header-icon">home</mat-icon>
        </div>
      </div>

      <div class="flex-table-cell flex-2">
        Type
        <filter-dropdown
          class="type-filter"
          [keyValueMap]="typeOptions"
          [filterObject]="getFilterForKey('type')"
          (toggleFilterEmitter)="toggleFilter($event)"
          (filterValueChanged)="onFilterValueChange($event)"
          placeholder="Selecteer Type"
        ></filter-dropdown>
      </div>

      <div class="flex-table-cell flex-2">Afm</div>

      <div class="flex-table-cell flex-2">
        Titel
        <filter-input
          [filterObject]="getFilterForKey('title')"
          [isDate]="false"
          (click)="$event.preventDefault() && $event.stopPropagation()"
          (toggleFilterEmitter)="toggleFilter($event)"
          (filterValueChanged)="onFilterValueChange($event)"
        ></filter-input>
      </div>

      <div class="flex-table-cell flex-2">
        Telnr
        <filter-input
          [filterObject]="getFilterForKey('phoneNumber')"
          [isDate]="false"
          (click)="$event.preventDefault() && $event.stopPropagation()"
          (toggleFilterEmitter)="toggleFilter($event)"
          (filterValueChanged)="onFilterValueChange($event)"
        ></filter-input>
      </div>

      <div class="flex-table-cell flex-2">
        <div
          class="flex-row clickable sort-container"
          (click)="activateSort('defaultLocation')"
          [ngClass]="{ 'sort-active': activeSort === 'defaultLocation' }"
        >
          <label class="clickable">Rek-nr</label>

          <mat-icon>
            <ng-container *ngIf="activeSortAscending; else descending">
              arrow_upward
            </ng-container>

            <ng-template #descending>arrow_downward</ng-template>
          </mat-icon>
        </div>

        <filter-input
          [filterObject]="getFilterForKey('defaultLocation__rack')"
          [isDate]="false"
          (click)="$event.preventDefault() && $event.stopPropagation()"
          (toggleFilterEmitter)="toggleFilter($event)"
          (filterValueChanged)="onFilterValueChange($event)"
        ></filter-input>
      </div>

      <div class="flex-table-cell flex-1">Design</div>

      <div class="flex-table-cell flex-1 text-center">Recup</div>

      <div class="flex-table-cell flex-1">
        <div
          class="flex-row clickable sort-container"
          (click)="activateSort('cachedStockAmount')"
          [ngClass]="{ 'sort-active': activeSort === 'cachedStockAmount' }"
        >
          <label class="clickable">Aantal</label>

          <mat-icon>
            <ng-container *ngIf="activeSortAscending; else descending">
              arrow_upward
            </ng-container>

            <ng-template #descending>arrow_downward</ng-template>
          </mat-icon>
        </div>
      </div>

      <div class="flex-table-cell flex-1">
        <div
          class="flex-row clickable sort-container"
          (click)="activateSort('minimumStock')"
          [ngClass]="{ 'sort-active': activeSort === 'minimumStock' }"
        >
          <label class="clickable">Min. voorraad</label>

          <mat-icon>
            <ng-container *ngIf="activeSortAscending; else descending">
              arrow_upward
            </ng-container>

            <ng-template #descending>arrow_downward</ng-template>
          </mat-icon>
        </div>
      </div>

      <div class="flex-table-cell flex-1">
        <div
          class="flex-row clickable sort-container"
          (click)="activateSort('stockOnFrame')"
          [ngClass]="{ 'sort-active': activeSort === 'stockOnFrame' }"
        >
          <label class="clickable">Kader</label>

          <mat-icon>
            <ng-container *ngIf="activeSortAscending; else descending">
              arrow_upward
            </ng-container>

            <ng-template #descending>arrow_downward</ng-template>
          </mat-icon>
        </div>
      </div>
      <div class="flex-table-cell flex-1">
        <div
          class="flex-row clickable sort-container"
          (click)="activateSort('physicalStockOnRoof')"
          [ngClass]="{ 'sort-active': activeSort === 'physicalStockOnRoof' }"
        >
          <label class="clickable">Dak</label>

          <mat-icon>
            <ng-container *ngIf="activeSortAscending; else descending">
              arrow_upward
            </ng-container>

            <ng-template #descending>arrow_downward</ng-template>
          </mat-icon>
        </div>
      </div>

      <div class="flex-table-cell flex-1">
        <div
          class="flex-row clickable sort-container"
          (click)="activateSort('physicalStockInRack')"
          [ngClass]="{ 'sort-active': activeSort === 'physicalStockInRack' }"
        >
          <label class="clickable">Rek</label>

          <mat-icon>
            <ng-container *ngIf="activeSortAscending; else descending">
              arrow_upward
            </ng-container>

            <ng-template #descending>arrow_downward</ng-template>
          </mat-icon>
        </div>
      </div>

      <div class="flex-table-cell flex-1">
        <div
          class="flex-row clickable sort-container"
          (click)="activateSort('stockInOffer')"
          [ngClass]="{ 'sort-active': activeSort === 'stockInOffer' }"
        >
          <label class="clickable">In Off.</label>

          <mat-icon>
            <ng-container *ngIf="activeSortAscending; else descending">
              arrow_upward
            </ng-container>

            <ng-template #descending>arrow_downward</ng-template>
          </mat-icon>
        </div>
      </div>

      <div class="flex-table-cell flex-1">Off. verz.</div>

      <div class="flex-table-cell flex-1">
        <div
          class="flex-row clickable sort-container"
          (click)="activateSort('graphicsFinished')"
          [ngClass]="{ 'sort-active': activeSort === 'graphicsFinished' }"
        >
          <label class="clickable">Graf.</label>

          <mat-icon>
            <ng-container *ngIf="activeSortAscending; else descending">
              arrow_upward
            </ng-container>

            <ng-template #descending>arrow_downward</ng-template>
          </mat-icon>
        </div>
      </div>

      <div class="flex-table-cell flex-1">
        <div
          class="flex-row clickable sort-container"
          (click)="activateSort('signComplete')"
          [ngClass]="{ 'sort-active': activeSort === 'signComplete' }"
        >
          <label class="clickable">Admin</label>

          <mat-icon>
            <ng-container *ngIf="activeSortAscending; else descending">
              arrow_upward
            </ng-container>

            <ng-template #descending>arrow_downward</ng-template>
          </mat-icon>
        </div>
      </div>
    </div>

    <ng-container *ngIf="loadingSigns; else tableContent">
      <mat-spinner color="primary" diameter="24"></mat-spinner>
    </ng-container>

    <ng-template #tableContent>
      <div class="flex-table-row" *ngFor="let sign of signs; index as i">
        <div
          class="flex-table-cell flex-4 clickable"
          (click)="signDetail(sign)"
        >
          <label [matTooltip]="sign.companiesDisplay" class="companies-label">
            {{ sign.companiesDisplay }}
          </label>
        </div>

        <div
          class="flex-table-cell flex-1 clickable"
          (click)="signDetail(sign)"
        >
          {{ sign.participatingCompanies?.length }}
        </div>

        <div
          class="flex-table-cell flex-2 clickable"
          (click)="signDetail(sign)"
        >
          {{ sign.type?.label }}
        </div>

        <div
          class="flex-table-cell flex-2 clickable"
          (click)="signDetail(sign)"
        >
          {{ sign.signMeasurementsDisplay }}
        </div>

        <div
          class="flex-table-cell flex-2 clickable"
          (click)="signDetail(sign)"
        >
          {{ sign.title }}
        </div>

        <div
          class="flex-table-cell flex-2 clickable"
          (click)="signDetail(sign)"
        >
          {{ sign.phoneNumber }}
        </div>

        <div
          class="flex-table-cell flex-2 clickable"
          (click)="signDetail(sign)"
        >
          <ng-container *ngIf="sign.defaultLocation">
            {{ sign.defaultLocation.rack }} - {{ sign.defaultLocation.shelf }} -
            {{ sign.defaultLocation.compartment }}
          </ng-container>
        </div>

        <div class="flex-table-cell flex-1">
          <ng-container *ngIf="sign.design && sign.design.asset">
            <img
              class="design-image clickable"
              *ngIf="isImage(sign.design.asset)"
              [src]="
                sign.design.asset.uuid
                  | assetSource : sign.design.asset.localSafeUrl
              "
              (click)="openLightbox(sign.design.asset)"
            />
          </ng-container>
        </div>

        <div
          class="flex-table-cell flex-1 clickable center"
          (click)="signDetail(sign)"
        >
          <div [ngSwitch]="sign.recupMethod.value">
            <div *ngSwitchCase="0">D</div>
            <div *ngSwitchCase="1">K</div>
            <div *ngSwitchCase="2">N</div>
          </div>
        </div>

        <div
          class="flex-table-cell flex-1 clickable"
          (click)="signDetail(sign)"
        >
          <span
            [ngClass]="
              sign.minimumStock != null &&
              (sign.cachedStockAmount == null ||
                sign.cachedStockAmount < sign.minimumStock)
                ? 'red-stock-amount'
                : ''
            "
          >
            {{ sign.cachedStockAmount ? sign.cachedStockAmount : 0 }}
          </span>
        </div>

        <div
          class="flex-table-cell flex-1 clickable"
          (click)="signDetail(sign)"
        >
          {{ sign.minimumStock }}
        </div>

        <div
          class="flex-table-cell flex-1 clickable"
          (click)="signDetail(sign)"
        >
          <span *ngIf="sign.stockOnFrame > 0">{{ sign.stockOnFrame }}</span>
        </div>

        <div
          class="flex-table-cell flex-1 clickable"
          (click)="signDetail(sign)"
        >
          <span *ngIf="sign.physicalStockOnRoof > 0">{{
            sign.physicalStockOnRoof
          }}</span>
        </div>

        <div
          class="flex-table-cell flex-1 clickable"
          (click)="signDetail(sign)"
        >
          <span *ngIf="sign.physicalStockInRack > 0">{{
            sign.physicalStockInRack
          }}</span>
        </div>

        <div
          class="flex-table-cell flex-1 clickable"
          (click)="signDetail(sign)"
        >
          <span *ngIf="sign.stockInOffer > 0">{{ sign.stockInOffer }}</span>
        </div>

        <div
          class="flex-table-cell flex-1 clickable"
          (click)="signDetail(sign)"
        >
          <ng-container *ngIf="sign.stockOfferSent">
            <mat-icon class="fa-2x green-text">check</mat-icon>
          </ng-container>
        </div>

        <div
          class="flex-table-cell flex-1 clickable"
          (click)="signDetail(sign)"
        >
          <ng-container *ngIf="sign.graphicsFinished; else notFinished">
            <mat-icon class="fa-2x green-text">check</mat-icon>
          </ng-container>

          <ng-template #notFinished>
            <mat-icon class="fa-2x red-text">warning</mat-icon>
          </ng-template>
        </div>

        <div
          class="flex-table-cell flex-1 clickable"
          (click)="signDetail(sign)"
        >
          <ng-container *ngIf="sign.signComplete; else notFinished">
            <mat-icon class="fa-2x green-text">check</mat-icon>
          </ng-container>

          <ng-template #notFinished>
            <mat-icon class="fa-2x red-text">warning</mat-icon>
          </ng-template>
        </div>
      </div>
    </ng-template>
  </div>
</div>

<mat-paginator
  [length]="totalItems"
  [pageSizeOptions]="pageSizeOptions"
  [showFirstLastButtons]="true"
  (page)="onPageChange()"
></mat-paginator>
